module.exports = __webpack_public_path__ + "img/logo2.31035bb7.png";